import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { setSelectedProductId } from "store/slice/PharmaSlice";
import { setOrderType } from "store/slice/AppSlice";
import { getCompositiontemplateInfoByTitleAPI } from "components/compositiontemplate/CompositiontemplateAPI";
import { getListAPI as getProductList } from "components/product/ProductAPI";
import { getProductInfoByPartyidAPI } from "components/product/ProductAPI";
import { setSelectedCTid } from "store/slice/AppSlice";

export default function SelectDrugCompositionTemplate({ sectionHeight }) {
  const dispatch = useDispatch();
  const { productList } = useSelector((state) => state.pharmaslice);
  const { partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);
  const [ctID, setCtID] = useState(null);
  const [filter, setFilter] = useState("");
  const { orderType } = useSelector((state) => state.appslice);
  const { compositiontemplateList } = useSelector((state) => state.pharmaslice);
  const [ctList, setCTList] = useState([]);
  const { userprofileInfo } = useSelector((state) => state.headerslice);
  const [compositionType, setCompositionType] = useState("Drug");

  useEffect(() => {
      if (filter !== '' && filter.length > 2) {
        getCompositiontemplateInfoByTitleAPI(filter, userprofileInfo.businessid, setCTList, (data) => {});
      } else {
        setCTList([]);
      }
  }, [filter]);


  const handleProductClick = (id) => {
    console.log("Selected CT ID:", id);
    setCtID(id);
    dispatch(setSelectedCTid(id));
  };


  return (

    <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
      <Grid lg={12} xs={12} item sx={{ padding: 1, backgroundColor: 'white', paddingBottom: 1, display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
        <TextField
          label="Filter Drug Composition"
          variant="outlined"
          size="small"
          value={filter}
          onChange={e => setFilter(e.target.value)}
          sx={{ width: '100%' }}
          InputProps={{
            startAdornment: (
              <SearchIcon sx={{ color: 'action.active', mr: 1 }} />
            ),
          }}
        />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
          Enter first 3 character of one of the item to fetch Composition List
        </Typography>
      </Grid>
      <Grid item lg={12} xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
        <Box sx={{ backgroundColor: 'white', flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%" }}>
          <Grid item lg={12} xs={12} sx={{ overflowY: "scroll", backgroundColor: 'white', minHeight: sectionHeight, maxHeight: sectionHeight, }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
              {ctList && ctList.length > 0 ? (
                [...ctList]
                  .filter(ctObj => ctObj.title.toLowerCase().includes(filter.toLowerCase()))
                  .sort((a, b) => a.title.localeCompare(b.title))
                  .map((ctObj) => {
                    return (
                      <Grid
                        lg={4}
                        md={6}
                        sm={3}
                        xs={12}
                        item
                        key={ctObj.id}
                        sx={{
                          width: '100%',
                          margin: 1,
                          backgroundColor: 'primary.lighter',
                          borderRadius: 1,
                          padding: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          border: '2px solid transparent',
                          opacity: 1,
                          transition: 'border-color 0.2s',
                          '&:hover': {
                            borderColor: 'primary.light'
                          },
                        }}
                      >
                        <Radio
                          checked={ctID === ctObj.id}
                          onChange={() => handleProductClick(ctID == ctObj.id ? null : ctObj.id)}
                          value={ctObj.id}
                          color="primary"
                          sx={{ mr: 1 }}
                        />
                        <Typography
                          variant="h6"
                          className="party-title"
                          onClick={() => handleProductClick(ctID == ctObj.id ? null : ctObj.id)}
                          sx={{
                            cursor: "pointer",
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                            maxWidth: "90hw", // Responsive max width for mobile/tablet/desktop
                            fontSize: { xs: 14, sm: 16 }, // Smaller font on mobile
                          }}
                        >
                          {ctObj.title}
                        </Typography>
                      </Grid>
                    );
                  })
              ) : (
                <Box
                  sx={{
                    minWidth: 200,
                    minHeight: 200,
                    backgroundColor: 'secondary.100',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2,
                    width: '80%',
                    m: 2

                  }}
                >
                  <Typography variant="h5" color="text.secondary" sx={{}}>
                    {filter === '' ? 'Enter first 3 character of one of the item to fetch Composition List' : 'Composition not found for the given filter. Please try again.'}
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}